var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('b-alert', {
    staticClass: "sa_note",
    attrs: {
      "show": "",
      "variant": "light"
    }
  }, [_c('div', [_c('strong', [_vm._v("03 節點標準電壓")]), _vm._v(" —— AC 電壓偏高／偏低判定的比較基準。 ")]), _c('ul', {
    staticClass: "mb-0 mt-1"
  }, [_c('li', [_c('strong', [_vm._v("電壓型態填錯會造成 √3 倍的判定偏差")]), _vm._v("，線電壓與相電壓不要混。 MPPT 電壓、STR 電壓也是合法值（分頁說明只寫兩種，以實際資料為準）。 ")]), _c('li', [_vm._v(" MPPT 節點不在拓撲表裡，但可以在這裡建列 —— 這張表刻意不對 02 下外鍵。 清單按「"), _c('strong', [_vm._v("由MPPT串列對應產生")]), _vm._v("」從主檔 05 帶，那邊有建過才產得出來。 ")]), _c('li', [_vm._v(" 額定範圍只驗下限小於上限。標準值有沒有落在範圍內"), _c('strong', [_vm._v("不擋")]), _vm._v("， 那是要驗出來給人看的，擋在庫外就驗不到了。 ")])])]), _c('MasterDataTable', _vm._g({
    attrs: {
      "table": "node_voltage_configs",
      "def": _vm.def,
      "site-code": _vm.siteCode
    }
  }, _vm.$listeners))], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };